import { AppError } from "./errors";
import { ChangeRequestCreateData, ChangeRequestUnsealData, SecretRef, SecretWithValue } from "./types";

export const ValidateVault = (data: string): AppError[] => {
    if (typeof data !== "string" || !/^(?!.*--)[a-zA-Z0-9-]{3,24}$/.test(data)) return [AppError("VaultNameInvalid", "vault")];
    return []
}

export const ValidateSecretName = (data: string): AppError[] => {
    if (typeof data !== "string" || !/^[a-zA-Z0-9-]{1,127}$/.test(data)) return [AppError("SecretNameInvalid", "name")];
    return [];
}

export const ValidateSecretValue = (data: string): AppError[] => {
    if (typeof data !== "string" || data.length === 0 || data.length > 25600) return [AppError("SecretValueInvalid", "value")];
    return []
}

export const ValidateSecretRef = (secret: SecretRef): AppError[] => {
    const errors: AppError[] = [];

    if (secret === undefined) {
        errors.push(AppError("SecretRefInvalid"))
    } else {
        errors.push(...ValidateVault(secret.vault));
        errors.push(...ValidateSecretName(secret.name));
    }

    return errors;
}

export const ValidateSecretData = (secret: SecretWithValue, source?: string): AppError[] => {
    const errors: AppError[] = [];

    if (secret === undefined) {
        errors.push(AppError("SecretDataInvalid"))
    } else {
        errors.push(...ValidateVault(secret.vault));
        errors.push(...ValidateSecretName(secret.name));
        errors.push(...ValidateSecretValue(secret.value));
    }

    return errors;
}

export const ValidateSecretUnique = (secrets: SecretWithValue[]): AppError[] => {
    const seen = new Set();

    const errors: AppError[] = [];

    let i = 0;
    for (let secret of secrets) {
        const _id = `secret/${secret.vault}/${secret.name}`
        if (seen.has(_id)) {
            errors.push(AppError("UniqueConstraint", `secret/${i}`))
        } else {
            seen.add(_id);
        }
        i++;
    }

    return errors;
}

export const ValidateChangeRequestDataSecrets = (secrets: SecretWithValue[]): AppError[] => {
    const errors: AppError[] = [];

    if (!Array.isArray(secrets) || secrets.length === 0) {
        errors.push(AppError("SecretsRequired", "secret"))
    } else {

        if (secrets.length > 10) {
            errors.push(AppError("SecretsTooMany", "secret"))
        }

        secrets.reduce((errors, secret, idx) => {
            const secret_errors = ValidateSecretData(secret).map(err => ({ ...err, source: `secret/${idx}/${err.source}` }));
            if (secret_errors.length > 0) errors.push(...secret_errors);
            return errors;
        }, errors)

        errors.push(...ValidateSecretUnique(secrets));
    }
    return errors;
}

export const ValidateJiraTicket = (data: string): AppError[] => {
    if (typeof data !== "string") return [AppError("TicketFormatInvalid", "ticket")];
    if (!/^[A-Z]{2,10}-[0-9]{1,7}$/.test(data)) return [AppError("TicketFormatInvalid", "ticket")];
    return []
}

export const ValidateDescription = (data: string): AppError[] => {
    if (typeof data !== "string" || data.trim().length < 10 || data.trim().length > 72) return [AppError("DescriptionInvalid", "description")];
    return [];
}

export const ValidateId = (id: number): AppError[] => {
    if (typeof id !== "number" || id <= 0 || id > 10000) return [AppError("ChangeRequestIdInvalid", "id")];
    return []
}

export const ValidateChangeRequestData = (data: ChangeRequestCreateData): AppError[] => {
    const errors: AppError[] = [];

    if (data === undefined) {
        errors.push(AppError("ValueRequired"))
    } else {
        errors.push(...ValidateJiraTicket(data.ticket));
        errors.push(...ValidateDescription(data.description));
        errors.push(...ValidateChangeRequestDataSecrets(data.secrets));
    }

    return errors;
}

export const ValidateUnsealRequestData = (data: ChangeRequestUnsealData): AppError[] => {
    const errors: AppError[] = [];

    if (data === undefined) {
        errors.push(AppError("ValueRequired"))
    } else {
        errors.push(...ValidateId(data.id));
        errors.push(...ValidateVault(data.secret.vault));
        errors.push(...ValidateSecretName(data.secret.name));
    }

    return errors;
}